import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  fileUploadService: [
    'runtimeConstant',
    '$filter',
    'webApiSettings',
    'FileUploader',
    'authService',
    function (
      runtimeConstant,
      $filter,
      webApiSettings,
      FileUploader,
      authService
    ) {
      var authData = authService.authentication;
      var isauth = authData.token !== null && authData.token !== '';

      var uploadOptions = {
        url: webApiSettings.apiServiceBaseUri + 'revisions/send',
        removeAfterUploading: true,
        headers: {
          Authorization: isauth ? 'Bearer ' + authData.token : '',
        },
      };

      var uploader = new FileUploader(uploadOptions);

      function onErrorItem(fileItem, response, status, headers) {
        // eslint-disable-next-line no-console
        console.info('onErrorItem', fileItem, response, status, headers);
        fileItem.isError = true;
        fileItem.isUploaded = false;
      }

      function onWhenAddingFileFailed(item, filter) {
        if (filter.name === 'imageFilter') {
          swal.fire({
            title: $filter('translate')('INVALID FILE FORMAT TITLE'),
            text: $filter('translate')('INVALID FILE FORMAT MESSAGE'),
            icon: 'warning',
            confirmButtonColor: 'red',
          });
        }
      }

      function getUploader() {
        return uploader;
      }

      function run() {
        try {
          var fileUploadServiceFactory = {};
          var fileLimit = 300;
          var fileSize = 0;

          uploader.filters.push({
            name: 'sizeFilter',
            fn: function (item) {
              fileSize = item.size / 1024 / 1024;
              if (fileSize < fileLimit) {
                return true;
              } else {
                swal.fire({
                  title:
                    $filter('translate')('FILE SIZE LIMIT') + fileLimit + 'MB',
                  text:
                    $filter('translate')('INVALID FILE SIZE') +
                    parseInt(fileSize) +
                    'MB',
                  icon: 'warning',
                  confirmButtonColor: 'red',
                });
                return false;
              }
            },
          });

          uploader.onErrorItem = logWrapper(
            onErrorItem,
            runtimeConstant.isDebugServicesInternals
          );
          uploader.onWhenAddingFileFailed = logWrapper(
            onWhenAddingFileFailed,
            runtimeConstant.isDebugServicesInternals
          );
          fileUploadServiceFactory.getUploader = logWrapper(
            getUploader,
            runtimeConstant.isDebugServicesInternals
          );

          return fileUploadServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
